import WarehouseOutlined from '@mui/icons-material/WarehouseOutlined';
import EProduct from '../products';
import routes from '../routes';
import { IProductConfig } from './Products.types';

const logisticsConfig: IProductConfig = {
  baseUrlProd: routes.ibProd,
  baseUrlSandbox: routes.ibSandbox,
  icon: <WarehouseOutlined />,
  modules: [
    {
      label: 'Warehouse',
      pageTitle: 'Warehouse',
      path: '/warehouse',
      roles: ['Test'],
    },
  ],
  product: EProduct.inbound,
  title: 'Logistics',
};

export default logisticsConfig;
